(function() {
  'use strict';

  var WIDGET_URL = 'https://judge.me/reviews/reviews_for_widget';
  var PER_PAGE = 30;
  var DISPLAY_PER_PAGE = 10;
  var MIN_RATING = 3;

  var section = document.getElementById('custom-reviews');
  if (!section) return;

  var productId = section.dataset.productId;
  var shopDomain = section.dataset.shopDomain;

  // Parse curated UGC media from metafield
  var metafieldUgc = [];
  try {
    var rawUgc = section.getAttribute('data-ugc-media');
    if (rawUgc) metafieldUgc = JSON.parse(rawUgc);
  } catch (e) { metafieldUgc = []; }

  var allReviews = [];
  var filteredReviews = [];
  var displayedCount = 0;
  var currentSort = 'recent';
  var totalCount = 0;
  var allFetched = false;
  var fetchPage = 1;
  var fetching = false;
  var parser = new DOMParser();

  // DOM refs
  var listEl = document.getElementById('cr-list');
  var ugcEl = document.getElementById('cr-ugc');
  var sortEl = document.getElementById('cr-sort');
  var loadMoreWrap = document.getElementById('cr-load-more');
  var loadMoreBtn = document.getElementById('cr-load-more-btn');
  var modal = document.getElementById('cr-modal');
  var form = document.getElementById('cr-review-form');
  var ratingInput = document.getElementById('cr-rating');
  var ratingStars = document.querySelectorAll('.cr__rating-star');
  var formError = document.getElementById('cr-form-error');
  var formSuccess = document.getElementById('cr-form-success');
  var submitBtn = document.getElementById('cr-submit-btn');

  // ===== SVG helpers =====
  function starSvg(filled) {
    return filled
      ? '<svg viewBox="0 0 24 24" fill="#000" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
  }

  function starsHtml(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) html += starSvg(i <= rating);
    return html;
  }

  // ===== Date formatting =====
  function fmtDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d)) {
      // Strip time/timezone from raw strings like "Jan 15, 2024 2:30 PM EST"
      var stripped = dateStr.replace(/\s+\d{1,2}:\d{2}.*$/, '').trim();
      d = new Date(stripped);
      if (isNaN(d)) return stripped;
    }
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var dd = ('0' + d.getDate()).slice(-2);
    return mm + '/' + dd + '/' + d.getFullYear();
  }

  // ===== Parse review from DOM element =====
  function parseReview(el) {
    var ratingEl = el.querySelector('.jdgm-rev__rating');
    var rating = ratingEl ? parseInt(ratingEl.dataset.score, 10) : 0;
    var author = (el.querySelector('.jdgm-rev__author') || {}).textContent || 'Anonymous';
    var initial = (el.querySelector('.jdgm-rev__icon') || {}).textContent || author.charAt(0);
    var tsEl = el.querySelector('.jdgm-rev__timestamp');
    var timestamp = tsEl ? (tsEl.dataset.content || tsEl.textContent) : '';
    var title = (el.querySelector('.jdgm-rev__title') || {}).textContent || '';
    var body = (el.querySelector('.jdgm-rev__body') || {}).textContent || '';
    var verified = el.dataset.verifiedBuyer === 'true';

    var photos = [];
    el.querySelectorAll('.jdgm-rev__pic-img').forEach(function(img) {
      var thumb = img.dataset.src || img.src || '';
      if (!thumb) return;
      var link = img.closest('.jdgm-rev__pic-link');
      var full = (link ? (link.getAttribute('data-mfp-src') || link.href) : '') || thumb;
      // Bump thumbnail to 320px for Retina sharpness
      var retinaThumb = thumb.replace(/([?&])w=\d+/, '$1w=320');
      photos.push({ thumb: retinaThumb, full: full });
    });

    return {
      rating: rating,
      author: author.trim(),
      initial: initial.trim().charAt(0).toUpperCase(),
      timestamp: timestamp.trim(),
      title: title.trim(),
      body: body.trim(),
      verified: verified,
      photos: photos
    };
  }

  // ===== Fetch reviews =====
  function fetchReviews(callback) {
    if (fetching || allFetched) return callback && callback();
    fetching = true;

    var url = WIDGET_URL
      + '?url=' + encodeURIComponent(shopDomain)
      + '&shop_domain=' + encodeURIComponent(shopDomain)
      + '&platform=shopify'
      + '&page=' + fetchPage
      + '&per_page=' + PER_PAGE
      + '&product_id=' + productId;

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.total_count) totalCount = data.total_count;

        var doc = parser.parseFromString(data.html || '', 'text/html');
        var revEls = doc.querySelectorAll('.jdgm-rev');

        if (revEls.length < PER_PAGE) allFetched = true;
        fetchPage++;

        revEls.forEach(function(el) {
          var review = parseReview(el);
          if (review.rating >= MIN_RATING) {
            allReviews.push(review);
          }
        });

        fetching = false;
        applySort();
        if (callback) callback();
      })
      .catch(function() {
        fetching = false;
        allFetched = true;
        if (callback) callback();
      });
  }

  // ===== Sort =====
  function applySort() {
    filteredReviews = allReviews.slice();
    if (currentSort === 'recent') {
      filteredReviews.sort(function(a, b) { return new Date(b.timestamp) - new Date(a.timestamp); });
    } else if (currentSort === 'highest') {
      filteredReviews.sort(function(a, b) { return b.rating - a.rating || new Date(b.timestamp) - new Date(a.timestamp); });
    } else if (currentSort === 'photos') {
      filteredReviews.sort(function(a, b) {
        return b.photos.length - a.photos.length || new Date(b.timestamp) - new Date(a.timestamp);
      });
    }
  }

  // ===== Escape helpers =====
  function escHtml(s) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(s));
    return div.innerHTML;
  }

  function escAttr(s) {
    return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ===== Render review card =====
  function renderCard(review) {
    var html = '<div class="cr__list-card">'
      + '<div class="cr__list-card__head">'
      + '<div class="cr__avatar">' + escHtml(review.initial) + '</div>'
      + '<span class="cr__list-card__stars">' + starsHtml(review.rating) + '</span>'
      + '<span class="cr__list-card__date">' + fmtDate(review.timestamp) + '</span>'
      + '</div>'
      + '<div class="cr__list-card__author">' + escHtml(review.author)
      + (review.verified ? '<span class="cr__list-card__verified">&check; verified</span>' : '')
      + '</div>';

    if (review.title) {
      html += '<div class="cr__list-card__title">' + escHtml(review.title) + '</div>';
    }
    if (review.body) {
      html += '<div class="cr__list-card__body">' + escHtml(review.body) + '</div>';
    }

    if (review.photos.length) {
      html += '<div class="cr__list-card__photos">';
      review.photos.forEach(function(p) {
        html += '<img class="cr__list-card__photo" src="' + escAttr(p.thumb) + '" data-full="' + escAttr(p.full) + '" alt="Review photo" loading="lazy" width="60" height="60">';
      });
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  // ===== Render list =====
  function renderList(reset) {
    if (reset) {
      displayedCount = 0;
      listEl.innerHTML = '';
    }

    var end = Math.min(displayedCount + DISPLAY_PER_PAGE, filteredReviews.length);
    var html = '';
    for (var i = displayedCount; i < end; i++) {
      html += renderCard(filteredReviews[i]);
    }
    listEl.insertAdjacentHTML('beforeend', html);
    displayedCount = end;

    // Show/hide load more
    if (displayedCount < filteredReviews.length || !allFetched) {
      loadMoreWrap.style.display = '';
    } else {
      loadMoreWrap.style.display = 'none';
    }

    // Empty state
    if (displayedCount === 0 && allFetched) {
      listEl.innerHTML = '<div style="padding:30px 0;text-align:center;color:#999;">no reviews yet for this product.</div>';
    }
  }

  // ===== Fisher-Yates shuffle =====
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  // ===== UGC photo strip =====
  function renderUgc() {
    // Normalize review photos
    var reviewMedia = [];
    allReviews.forEach(function(r) {
      r.photos.forEach(function(p) {
        if (reviewMedia.length < 20) reviewMedia.push({ type: 'image', thumb: p.thumb, full: p.full });
      });
    });

    // Combine with metafield UGC and shuffle
    var combined = reviewMedia.concat(metafieldUgc);
    shuffle(combined);

    // Show/hide "Pictures First" sort option based on photo availability
    var photosOption = sortEl.querySelector('option[value="photos"]');
    if (!combined.length) {
      ugcEl.style.display = 'none';
      if (photosOption) photosOption.style.display = 'none';
      return;
    }

    if (photosOption) photosOption.style.display = '';
    ugcEl.style.display = '';
    var html = '';
    combined.forEach(function(item) {
      if (item.type === 'video') {
        html += '<div class="cr__ugc-item cr__ugc-item--video" data-full="' + escAttr(item.full) + '" data-type="video">'
          + '<video class="cr__ugc-vid" data-src="' + escAttr(item.full) + '" muted loop playsinline preload="none"></video>'
          + '<svg class="cr__ugc-play" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19" fill="rgba(0,0,0,.5)" stroke="#fff" stroke-width="2"/><polygon points="16,12 30,20 16,28" fill="#fff"/></svg>'
          + '</div>';
      } else {
        html += '<img class="cr__ugc-img" src="' + escAttr(item.thumb) + '" data-full="' + escAttr(item.full) + '" alt="Customer photo" loading="lazy" decoding="async">';
      }
    });
    ugcEl.innerHTML = html;

    // Auto-play video thumbnails when visible, pause when not
    ugcEl.querySelectorAll('.cr__ugc-vid').forEach(function(video) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
              video.load();
            }
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });
      observer.observe(video);
    });
  }

  // ===== Lightbox =====
  function openLightbox(fullSrc, mediaType) {
    var lb = document.createElement('div');
    lb.className = 'cr__photo-lightbox';
    if (mediaType === 'video') {
      lb.innerHTML = '<button class="cr__lightbox-close" aria-label="Close">&times;</button>'
        + '<video class="cr__lightbox-video" src="' + escAttr(fullSrc) + '" autoplay playsinline controls></video>';
      lb.querySelector('.cr__lightbox-close').addEventListener('click', function(e) {
        e.stopPropagation();
        var v = lb.querySelector('video');
        if (v) { v.pause(); v.src = ''; }
        lb.remove();
      });
      lb.addEventListener('click', function(e) {
        if (e.target === lb) {
          var v = lb.querySelector('video');
          if (v) { v.pause(); v.src = ''; }
          lb.remove();
        }
      });
    } else {
      lb.innerHTML = '<img src="' + escAttr(fullSrc) + '" alt="Review photo">';
      lb.addEventListener('click', function() { lb.remove(); });
    }
    document.body.appendChild(lb);
  }

  // ===== Event: sort =====
  sortEl.addEventListener('change', function() {
    currentSort = this.value;
    applySort();
    renderList(true);
  });

  // ===== Event: load more =====
  loadMoreBtn.addEventListener('click', function() {
    if (displayedCount >= filteredReviews.length && !allFetched) {
      fetchReviews(function() { renderList(false); });
    } else {
      renderList(false);
    }
  });

  // ===== Event: photo/video click (lightbox) =====
  document.addEventListener('click', function(e) {
    // Video item wrapper
    var videoItem = e.target.closest('.cr__ugc-item--video');
    if (videoItem && videoItem.dataset.full) {
      e.preventDefault();
      openLightbox(videoItem.dataset.full, 'video');
      return;
    }
    // Image
    var img = e.target.closest('.cr__list-card__photo, .cr__ugc-img');
    if (img && img.dataset.full) {
      e.preventDefault();
      openLightbox(img.dataset.full, 'image');
    }
  });

  // ===== Write review modal =====
  document.querySelectorAll('[data-cr-open-form]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      modal.style.display = '';
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('[data-cr-close-form]').forEach(function(el) {
    el.addEventListener('click', function() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  });

  // Star rating input
  function setRating(val) {
    ratingInput.value = val;
    ratingStars.forEach(function(star) {
      var r = parseInt(star.dataset.rating, 10);
      star.classList.toggle('active', r <= val);
    });
  }

  ratingStars.forEach(function(star) {
    star.addEventListener('click', function() {
      setRating(parseInt(this.dataset.rating, 10));
    });
  });

  setRating(5);

  // ===== Submit review =====
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    formError.style.display = 'none';
    formSuccess.style.display = 'none';

    var name = document.getElementById('cr-name').value.trim();
    var email = document.getElementById('cr-email').value.trim();
    var rating = parseInt(ratingInput.value, 10);
    var title = document.getElementById('cr-review-title').value.trim();
    var body = document.getElementById('cr-body').value.trim();

    if (!name || !email || !title || !body) {
      formError.textContent = 'please fill in all required fields.';
      formError.style.display = '';
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      formError.textContent = 'please enter a valid email address.';
      formError.style.display = '';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'submitting...';

    var hpEl = document.getElementById('cr-hp');
    var payload = {
      shopDomain: shopDomain,
      productId: productId,
      name: name,
      email: email,
      rating: rating,
      title: title,
      body: body,
      hp: hpEl ? hpEl.value : ''
    };

    fetch('https://full-story-utilities-production.up.railway.app/api/public/judgeme-review', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      return res.json().catch(function() { return { ok: res.ok }; })
        .then(function(data) { return { res: res, data: data }; });
    })
    .then(function(r) {
      if (r.res.ok && r.data && r.data.ok) {
        formSuccess.style.display = '';
        form.reset();
        setRating(5);
      } else {
        formError.textContent = (r.data && r.data.error)
          ? r.data.error
          : 'there was an error submitting your review. please try again.';
        formError.style.display = '';
      }
    })
    .catch(function() {
      formError.textContent = 'there was an error submitting your review. please try again.';
      formError.style.display = '';
    })
    .finally(function() {
      submitBtn.disabled = false;
      submitBtn.textContent = 'submit review';
    });
  });

  // ===== Keyboard: close modal/lightbox on Escape =====
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    // Close lightbox (video or image)
    var lb = document.querySelector('.cr__photo-lightbox');
    if (lb) {
      var v = lb.querySelector('video');
      if (v) { v.pause(); v.src = ''; }
      lb.remove();
      return;
    }
    // Close review modal
    if (modal.style.display !== 'none') {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  // ===== Init: fetch immediately (script is already defer-loaded) =====
  // Fetch page 1 → render list, then auto-fetch a few more pages for UGC photos
  var initDone = false;
  fetchReviews(function() {
    renderList(true);
    renderUgc();
    initDone = true;
    // Auto-fetch extra pages in the background to populate UGC photo strip
    fetchMoreForUgc(3);
  });

  function fetchMoreForUgc(remaining) {
    if (remaining <= 0 || allFetched) return;
    fetchReviews(function() {
      renderUgc();
      fetchMoreForUgc(remaining - 1);
    });
  }
})();
